<div *ngIf="agentMode" class="govuk-width-container">
  <button type="button" class="btn btn-primary" data-module="govuk-button" (click)="datastoreService?.agentRestart()">
    Agent Restart
  </button>
</div>

<div class="row breadcrumb-container">
  <div class="col-12">
    <div class="govuk-width-container">
      <govuk-ui-breadcrumb [items]="breadcrumbItems"></govuk-ui-breadcrumb>
    </div>
  </div>
</div>
<main id="main-content" tabindex="-1">
  <div class="row page-heading-container">
    <div class="col-12">
      <gb-ui-page-heading [titleText]="this.selectedDepartment?.extra?.services_page_title"></gb-ui-page-heading>
    </div>
  </div>
  <div class="govuk-width-container">
    <div class="govuk-main-wrapper govuk-main-wrapper--l">
      <div class="govuk-grid-row">
        <div class="govuk-grid-column-full" [innerHTML]="this.selectedDepartment?.extra?.service_page_introduction">
        </div>

        <div class="govuk-grid-column-full" *ngIf="loadedConfig">
          <!-- Hardcoded initial questions -->
          <form [formGroup]="initQuestions" *ngIf="this.journey === 'default'">
            <div class="govuk-form-group">
              <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                for="ceramony_type">
                Which type of ceremony are you booking?
              </label>

              <select aria-required="true" (change)="validateAppointmentTypeQuestion($event)"
                formControlName="type_of_appointment" class="govuk-select govuk-select--inverse" id="ceramony_type"
                name="ceramony_type">
                <option *ngFor="let option of config?.journey_config?.ceremonies['ceremony_types_dropdown']"
                  [value]="option.form_schema">
                  {{ option.name }}
                </option>
              </select>
            </div>

            <div class="govuk-inset-text" *ngIf="invalidInitForm === 'over_two_years'">
              {{ 'SERVICES.CERMONY_ADVISE' | translate }}
            </div>
          </form>

          <div *ngIf="showOther" [innerHTML]="
          this.selectedDepartment?.extra?.service_page_type_of_ceremony_other
        "></div>

          <ng-container *ngIf="showFormBuilder">
            <lib-form-builder [appConfig]="appConfig" [formId]="selectedFormId" [formData]="formData"
              [showSubmit]="false" companyId="37002" maxCertificates="1" (formReady)="formReady($event)"
              (formStatus)="updateAnswers($event)" (formSubmit)="selectService()" (schema)="storeSchema($event)"
              (companySet)="onCompanySet($event)" (serviceSet)="onServiceSet($event)"
              (resourceSet)="onResourceSet($event)" (staffSet)="onStaffSet($event)"
              (addDuration)="onAddDuration($event)" (addressSet)="onAddressSet($event)"
              (extraItemSet)="onExtraItemSet($event)" (venueSet)="onVenueSet($event)">
            </lib-form-builder>
          </ng-container>


          <!-- <div *ngIf="showServices && companyQuestionsForm.valid">
          <div class="govuk-button-group">
            <button type="submit" class="govuk-button govuk-button--inverse" data-module="govuk-button"
              (click)="selectService()">
              {{ 'COMMON.NEXT' | translate }}
            </button>
          </div>
        </div> -->

          <!-- <ng-container *ngIf="showServices && !companyQuestionsForm.valid">
          <div role="alert" class="guidance-message cannot-proceed ng-star-inserted">
            <p><strong>Please complete the form above to proceed</strong>.</p>
          </div>
        </ng-container> -->

          <div *ngIf="!ageType.includes('16') && ageType.includes('10')">
            <div class="alert alert-danger mb-3" role="alert">
              <!-- {{ 'COMMON.HAS_COVID_SYMPTOMS' | translate }} -->
              <div class="pageTitle" *ngIf="translateService.currentLang === 'en'">
                {{ this.selectedDepartment?.extra?.under_10_guidance_text }}
              </div>
              <div class="pageTitle" *ngIf="translateService.currentLang === 'cy'">
                {{ this.selectedDepartment?.extra?.under_10_guidance_text_welsh }}
              </div>
            </div>
          </div>

          <!-- -->
          <ng-container *ngIf="!showServices && citizenshipExpired">
            <wcc-warning-box [question]="{
              component_text: 'Your Home Office reference has passed the required by date. Please contact the registrar office.'
            }" [returnConfig]="{}">
            </wcc-warning-box>
          </ng-container>
        </div>
      </div>
    </div>
